<ng-scrollbar style="height: calc(100vh - 88px)" visibility="hover">
  <br/>
  @if (showContent) {
    <app-card [showHeader]="false" cardClass="user-card" padding="20">
      <div class="flex align-items-center">

        <div class="flex-grow-1 user-details">
          <div class="f-w-600">{{ user?.contact?.firstName }} {{ user?.contact?.lastName }}</div>
          <div class="mat-caption">{{property?.name || 'Ninguno'}}</div>
        </div>
        <div class="user-setting">
          <a href="javascript:"
             class="text-muted"
             matTooltip="Cambiar propietario"
             (click)="clickChangeProperty()"
          >
            <i class="fi fi-br-replace"></i>
          </a>
        </div>
      </div>
    </app-card>
  }
  <div class="navbar-content">
    <ul class="nav coded-inner-navbar" (click)="fireOutClick()">
      @for (item of menuResult; track item.id) {
        @if (item.type === 'group') {
          <app-menu-group-vertical [item]="item"></app-menu-group-vertical>
        } @else if (item.type === 'collapse') {
          <app-menu-collapse [item]="item"></app-menu-collapse>
        } @else if (item.type === 'item') {
          <app-menu-item [item]="item"></app-menu-item>
        }
      }
    </ul>
  </div>
</ng-scrollbar>
